import { Component, OnInit } from '@angular/core';
import { toInteger } from 'lodash';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'dmp-row-detail',
    templateUrl: './row-detail.component.html',
    styleUrls: ['./row-detail.component.scss'],
    standalone: false
})
export class RowDetailComponent implements OnInit {
  rowData:any
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  infoCommand: any[];

  ngOnInit() {
    this.rowData=this.config.data.rowData;
    const d = this.rowData;
    this.infoCommand = [
      {
        label: "Numéro de transaction",
        value: d.booking_reference,
        type: "STRING"
      },
      {
        label: "Date de commande",
        value: d.booking_reference,
        type: "DATE"
      },
      {
        label: "Date de départ",
        value: d.booking_reference,
        type: "DATE"
      },
      {
        label: "Date de retour",
        value: d.booking_reference,
        type: "DATE"
      },
      {
        label: "Adresse",
        value: d.booking_reference,
        type: "DATE"
      },
      {
        label: "Départ",
        value: d.booking_reference,
        type: "STRING"
      },
      {
        label: "Arrivée",
        value: d.booking_reference,
        type: "STRING"
      },

    ];
  }

  toDate(d: string){
    if(d){
      const date = new Date(d);
      return date.toLocaleDateString('Fr-fr');
    } else {
      return null;
    }
  }

  getNbPassager(d:any): number{
    let c = 0;
    if(d){
      [ d.pax_number_adults, 
        d.pax_number_children, 
        d.pax_number_babies
      ].forEach(n => {
        if(n){
          try {
            c += toInteger(n);
          } catch (error) {
            // Not yet
          }
        }
      });  
    }
    
    return c;
  }

}
